export enum TipoIniciacaoTransferencia {
	FAVORECIDO_CADASTRADO = 'FAVORECIDO_CADASTRADO',
	FAVORECIDO_NAO_CADASTRADO = 'FAVORECIDO_NAO_CADASTRADO',
	QRCODE = 'QRCODE'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/tipo-iniciacao-transacao.enum.ts